import * as Yup from 'yup';

export interface SectionForm {
  label: string;
}

export type SectionFormShape = {
  [key in keyof SectionForm]?: any;
};

export const schema = Yup.object().shape<SectionFormShape>({
  label: Yup.string().required('Digite um nome'),
});
